import { Directive, AfterViewInit   } from "@angular/core";

@Directive({
  selector: ".input-auto-tab"
})
export class AutoTabDirective implements AfterViewInit {

  constructor() {}

  ngAfterViewInit() {
    Array.from(window.document.querySelectorAll(`.input-auto-tab input`))
      .map(function (input: HTMLInputElement, idx: number, wrapper: any[]) {
        input.addEventListener("keyup", () => {
          if (input.value.length === input.maxLength) {
            if (wrapper[idx + 1]) {
              wrapper[idx + 1].focus();
            }
          }
        });
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/auto-tab.directive.ts